export const environment = {
  production: false,
  apis: {
    'communication-api': 'https://myi-communication-api.azurewebsites.net/',
    'organization-api': 'https://myi-organization-api.azurewebsites.net',
    'ai-api': 'https://myi-ai-api.azurewebsites.net',
  },
  msalConfig: {
    auth: {
      clientId: '37b2461e-5a85-4a30-a83c-455951c23973',
      authority: 'https://myivideo.ciamlogin.com/',
      knownAuthorities: ['MYIVideo.ciamlogin.com', 'login.microsoftonline.com'],
      redirectUri: 'https://myivideo.dev',
      postLogoutRedirectUri: 'https://myivideo.dev',
    },
    authorities: {
      myi: 'https://myivideo.ciamlogin.com/',
      organizations: 'https://login.microsoftonline.com/organizations',
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: any, message: string, containsPii: boolean) => {
          if (containsPii) {
            return;
          }
          console.log(message);
        },
        logLevel: 3, // More verbose logging for dev
        piiLoggingEnabled: false,
      },
    },
  },
  apiConfig: {
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    uri: '',
  },
  betaAccessCode: 'MYI-BETA-2025',
};
